export enum NotificationType {
  Info = 'info',
  Error = 'danger',
  Warning = 'warning',
  Success = 'success'
}

export type UINotification = {
  type: NotificationType;
  message: string;
}
